const calculateLineWrap = (container)=>{
    return Math.round(container.clientHeight / parseFloat(getComputedStyle(container).lineHeight));
};

export { calculateLineWrap };
//# sourceMappingURL=calculate-line-wrap.js.map
